var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutomation = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 575.697,
    height: 800,
    viewBox: "0 0 575.697 800",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a-167"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.248,
    cy: 25.248,
    r: 25.248,
    fill: "none",
    stroke: "#090814",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-633.664 -70)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.314,
    height: 543.696,
    transform: "matrix(-0.99, -0.141, 0.141, -0.99, 1076.558, 728.602)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 216.355,
    height: 7.766,
    transform: "translate(993.007 846.75)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,367.654,191.919,625.64l7.5-2L135.2,365.67Z",
    transform: "translate(976.457 228.498)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.095,
    cy: 11.095,
    rx: 11.095,
    ry: 11.095,
    transform: "translate(1092.863 584.904)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.126,0H2.762L0,33.283H28.523Z",
    transform: "translate(682.363 404.604)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.432,689.43h15.194l7.229-58.612H94.425Z",
    transform: "translate(653.772 150.66)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.817,4.511,24.3,0,0,53.862l21.43,6.653Z",
    transform: "translate(709.201 831.071) rotate(156.997)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.724,559.068l-9.491,11.03,12.274,224.143h26.229l13.218-172.474,41,177.1,27.266-6.687L843.431,567.243Z",
    transform: "translate(-94.5 19.99)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.1,401.472l-26.114-13.1-40.158.706L770.269,406.76l19.663,98.2-8.493,51.2h0a209.434,209.434,0,0,0,100.157.825l.262-.063s-19.521-69.262-11.21-90.4Z",
    transform: "translate(-128.508 32.876)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.638,343.529a29.568,29.568,0,1,1,0,.219Z",
    transform: "translate(-132.594 38.485)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.313,478.792a10.6,10.6,0,0,1-15.393,5.2L778.9,512.024l-1.713-12.916,51.524-30.383a10.654,10.654,0,0,1,18.612,10.067Z",
    transform: "translate(-101.117 27.153)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.217,481.038a10.6,10.6,0,0,0,16.159,1.709L850.25,498.5l-.5-16.4-57.571-14.952a10.654,10.654,0,0,0-15.96,13.9Z",
    transform: "translate(-100.681 27.14)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.791,408.973l-11.284-.707S820.3,425.7,827.623,444.615c0,0-1.27,67.952,27.99,65.16s38.5-2.8,38.5-2.8l-8.783-24.5-19.649-6.067s6.056-26.713-5.41-37.827Z",
    transform: "translate(-191.745 31.375)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.478,407.718l1.6-8.176s23.52-.555,28.17,35.086c0,0,21.15,53.337.419,60.205s-43.534,0-43.534,0l1.713-23.523,22.808-4.653s-11.783-15.245-5.367-28.467Z",
    transform: "translate(-26.948 32.032)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.326,357.371c2.175-.854,4.584-.812,6.884-1.231,8.222-1.515,14.564-9.9,13.783-18.222a10.025,10.025,0,0,1-.053-3.266c.57-2.375,3.209-3.65,5.635-3.934s4.931.079,7.29-.552c3.642-.976,6.363-4.3,7.286-7.953a18.015,18.015,0,0,0-1.172-11.061l-1.132,2.36a9.17,9.17,0,0,1-2.317-4.486,5.783,5.783,0,0,0-4.779,3.025c-1.462.653-1.283-2.687-2.74-3.348a2.736,2.736,0,0,0-1.941.253c-3.211,1.078-6.616-.541-9.8-1.7a37.366,37.366,0,0,0-17.235-1.969,20.794,20.794,0,0,0-10.78,4.086,24.6,24.6,0,0,0-5.692,7.649c-3.713,6.943-6.511,14.6-6.436,22.475a32.633,32.633,0,0,0,5.7,18.046c1.894,2.76,8.025,12.336,12.1,11.282C821.044,367.506,815.2,359.773,821.326,357.371Z",
    transform: "translate(-134.943 39.165)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.749,30.032s-10.009,7.342-10.009,3.337S9.39,13.346,9.39,13.346-9.3,0,6.054,0,28.079,2.666,28.079,2.666L44.094,13.346s4,4.672,2.67,10.009-6.006,12.685-6.006,12.685S35.421,28.7,30.749,30.032Z",
    transform: "translate(719.143 857.035) rotate(164)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.353,787.5s1.381-6.906,6.216-3.454,17.957,13.813,17.957,13.813,24.173,5.525,8.978,12.432-49.728-2.763-49.728-2.763-1.381-22.1,0-21.411S384.662,788.879,385.353,787.5Z",
    transform: "translate(377.881 45.489)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(717.828 129.514)",
    fill: "#6c63ff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216.414,
    height: 28.855,
    rx: 14.428,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 215.414,
    height: 27.855,
    rx: 13.928,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(846.774 208.866)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#f2f2f2",
    stroke: "#090814",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216.414,
    height: 97.386,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 214.414,
    height: 95.386,
    rx: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.576,39.144A18.574,18.574,0,1,1,20.576,2a1.859,1.859,0,1,1,0,3.718A14.858,14.858,0,1,0,35.43,20.572a1.857,1.857,0,1,1,3.715,0A18.593,18.593,0,0,1,20.576,39.144Z",
    transform: "translate(87.636 28.124)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(717.828 70)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.248,
    cy: 25.248,
    r: 25.248,
    transform: "translate(0 1.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.248,1.8a23.452,23.452,0,0,0-9.125,45.048A23.451,23.451,0,0,0,34.374,3.645,23.3,23.3,0,0,0,25.248,1.8m0-1.8A25.248,25.248,0,1,1,0,25.248,25.248,25.248,0,0,1,25.248,0Z",
    transform: "translate(0 1.803)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a-167)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.96 10.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.968,0H1.054L0,12.7H10.883Z",
    transform: "translate(15.492 23.053)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.74,393.369l-9.964-5-15.322.269-13.185,6.747,7.5,37.466-3.241,19.535h0a79.907,79.907,0,0,0,38.214.315l.1-.024s-7.448-26.426-4.277-34.49Z",
    transform: "translate(-770.269 -358.967)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.638,325.3a11.276,11.276,0,1,1,0,.084Z",
    transform: "translate(-789.991 -310.87)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.978,324.993a13.86,13.86,0,0,1,2.626-.47,6.689,6.689,0,0,0,5.259-6.952,3.826,3.826,0,0,1-.02-1.246,2.359,2.359,0,0,1,2.15-1.5,19.379,19.379,0,0,0,2.781-.211,4.151,4.151,0,0,0,2.78-3.034,6.874,6.874,0,0,0-.447-4.22l-.432.9a3.5,3.5,0,0,1-.884-1.712,2.206,2.206,0,0,0-1.823,1.154c-.558.249-.49-1.025-1.046-1.277a1.044,1.044,0,0,0-.741.1c-1.225.411-2.524-.206-3.738-.647a14.257,14.257,0,0,0-6.576-.751,7.934,7.934,0,0,0-4.113,1.559,9.383,9.383,0,0,0-2.172,2.919,18.1,18.1,0,0,0-2.456,8.575,12.452,12.452,0,0,0,2.174,6.885c.723,1.053,3.062,4.707,4.616,4.3C806.87,328.86,804.641,325.91,806.978,324.993Z",
    transform: "translate(-789.952 -305.019)",
    fill: "#090814"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 25.248,
    cy: 25.248,
    r: 25.248,
    transform: "translate(1012.692 151.155)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.248,1.8a23.452,23.452,0,0,0-9.125,45.048A23.451,23.451,0,0,0,34.374,3.645,23.3,23.3,0,0,0,25.248,1.8m0-1.8A25.248,25.248,0,1,1,0,25.248,25.248,25.248,0,0,1,25.248,0Z",
    transform: "translate(1012.692 149.352)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1022.998 158.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.515,26.778A6.515,6.515,0,0,1,11,20.262V18.515A6.515,6.515,0,0,1,17.515,12a.4.4,0,1,1,0,.793,5.723,5.723,0,0,0-5.723,5.723v1.747a5.723,5.723,0,1,0,11.445,0V17.116a.4.4,0,1,1,.793,0v3.146a6.516,6.516,0,0,1-6.516,6.516Z",
    transform: "translate(3.546 5.483)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.515,26.78A6.515,6.515,0,0,1,4,20.263V17.117a.4.4,0,1,1,.793,0v3.146a5.723,5.723,0,0,0,11.445,0V18.516a5.723,5.723,0,0,0-5.723-5.723.4.4,0,0,1,0-.793,6.515,6.515,0,0,1,6.515,6.515v1.747a6.516,6.516,0,0,1-6.516,6.516Z",
    transform: "translate(-1.691 5.482)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.634,13.807a.4.4,0,0,1-.4-.4v-4.9a5.723,5.723,0,1,0-11.445,0,.4.4,0,1,1-.793,0,6.515,6.515,0,1,1,13.031,0v4.9a.4.4,0,0,1-.4.4Z",
    transform: "translate(3.546 -2)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.634,26.395a.4.4,0,0,1-.4-.4V8.516a5.723,5.723,0,0,0-11.445,0v4.9a.4.4,0,0,1-.793,0v-4.9a6.515,6.515,0,1,1,13.03,0V26A.4.4,0,0,1,16.634,26.395Z",
    transform: "translate(-1.692 -2)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.655 3.497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3,21.03a.4.4,0,1,1,0-.793,5.723,5.723,0,1,0,0-11.445h-.874a.4.4,0,0,1,0-.793H17.3a6.515,6.515,0,1,1,0,13.031Z",
    transform: "translate(-14.584 -1.007)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.924,15.786a.4.4,0,1,1,0-.793,3.1,3.1,0,1,0,0-6.2h-.5a.4.4,0,0,1,0-.793h.5a3.893,3.893,0,1,1,0,7.786Z",
    transform: "translate(-16.018 -8)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.868,15.786h-.5a.4.4,0,1,1,0-.793h.5a3.1,3.1,0,1,0,0-6.2.4.4,0,0,1,0-.792,3.893,3.893,0,1,1,0,7.786Z",
    transform: "translate(-15.961 10.835)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.514,21.03A6.515,6.515,0,1,1,22.514,8h.874a.4.4,0,1,1,0,.793h-.874a5.723,5.723,0,0,0,0,11.445.4.4,0,0,1,0,.793Z",
    transform: "translate(-15.999 -1.006)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.892,15.785a3.893,3.893,0,1,1,0-7.786h.5a.4.4,0,1,1,0,.793h-.5a3.1,3.1,0,1,0,0,6.2.4.4,0,0,1,0,.792Z",
    transform: "translate(-11.568 -7.999)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.391,15.785h-.5a3.893,3.893,0,1,1,0-7.786.4.4,0,1,1,0,.793,3.1,3.1,0,1,0,0,6.2h.5a.4.4,0,1,1,0,.793Z",
    transform: "translate(-11.568 10.835)",
    fill: "#090814"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutomation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/automation.8c2de4a37e9adc89c5e6a474bb3442ff.svg";